const ContactUsScreen = () => {
  
    return (
       <p>Contact Us Screen here</p>
    )
}

export default ContactUsScreen